<template>
  <div class="container">
    <ProfileTitleComponent
      :title="$t('learn_my_videos.title')"
      :subtitle="$t('learn_my_videos.subtitle')"
    />
    <div class="row">
    
      <div 
        v-for="video in user.videos"
        :key="video.id"
        class="col-12 col-md-6 p-2 mt-4"
      >
        <div 
          v-if="video.transcode_status === 'complete'"
          style="padding:56.25% 0 0 0;position:relative;"
        >
          <iframe 
            :src="`https://player.vimeo.com/video/${video['vimeo_id']}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`" 
            frameborder="0" 
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" 
            style="position:absolute;top:0;left:0;width:100%;height:100%;" 
          />
        </div>

        <div
          v-else-if="video.transcode_status === 'in_progress'"
        >
          <strong> {{ $t('learn_my_videos.video_upload_in_progress') }} </strong>
        </div>

        <div class="video-details mt-2">
          <div>
            <strong>{{video.title}}</strong>
            <br>
            <span 
              v-if="video.categories"
              class="text-muted"
            > 
              {{video.categories?.join(', ')}}
            </span>
            <br>
            <span
              class="text-muted"
            >
              {{ $t('learn_my_videos.created_at', { createdAt: $dayjs(video.created_at).format('DD/MM/YYYY'), updatedAt: $dayjs(video.updated_at).format('DD/MM/YYYY') }) }}
            </span>
          </div>
          <div>

            <img
              @click="$router.push('/user/account/content/edit/' + video.id)"
              src="@/assets/images/video/edit-icon.svg"
              class="video-details--edit-icon"
              width="20"
            />
          </div>

        </div>
        
      </div>
    </div>

    <div class="profile-footer">
      <div 
        @click='$router.go(-1)'
        class="profile-back-pc-button"
      >
        <img
          src="@/assets/images/button/back/back_pc.svg"
          :alt="$t('learn_my_videos.back')"
        />
      </div>
      <button
        class="profile-validation-button"
        @click="$router.push('/user/account/content/new')"
      >
        {{ $t('learn_my_videos.add_new_content') }}
      </button>
    </div>
  </div>
</template>

<script src="https://player.vimeo.com/api/player.js"></script>

<script>

import { APIUserConnected } from '@/api/APIUserConnected'
import ProfileTitleComponent from '@/components/user/profile/ProfileTitleComponent'

const apiUserConnected = new APIUserConnected()

export default {
  name: 'LearnNewVideo',
  components: { ProfileTitleComponent },
  data() {
    return {
      user: {
        videos: []
      },
    }
  },
  computed: {
    token () {
      return this.$store.state.auth.token
    }
  },
  async created() {
    this.$store.commit('loadFromAPI')
    await this.getCurrentUser()
    this.$store.commit('endLoadingFromAPI')
  },
  methods: {
    async deleteVideo (videoId) {
      this.$store.commit('loadFromAPI')
      await apiUserConnected.deleteVideo(videoId)
      await this.getCurrentUser()
      this.$store.commit('endLoadingFromAPI')
    },
    async getCurrentUser () {
      return apiUserConnected.getCurrentUser()
      .then((response) => {
        this.user = response.data
      }, (error) => {
        throw new Error('getCurrentUser API Error : ' + String(error))
      })
    },
  },
}
</script>

<style>
.video-details {
  display: flex;
  justify-content: space-between;
}

.video-details--edit-icon {
  cursor: pointer;
}
</style>